import { BaseItemResponse } from "../../response/BaseItemResponse";
import { BasePayload } from "../api/payload/BasePayload";
import { IListCache } from "./IListCache";

/** Base de los guardados: envía el payload por gRPC-Web (`sendSave`) y refleja el resultado en el listado. */
export abstract class ServiceSaveBase<
  TItem extends BaseItemResponse,
  TPayload extends BasePayload,
> {
  /** Servicio de listado cuya lista en memoria refleja el guardado. Los adaptadores
   *  que no alimentan ningún listado (gastos, asignaciones) lo omiten. */
  protected readonly cache?: IListCache<TItem>;

  /** Guarda y, si hay listado asociado (`cache`), hace `upsert` del item devuelto por el servidor. */
  async save(request: TPayload): Promise<TItem> {
    const item = await this.sendSave(request);
    this.cache?.upsert(item);
    return item;
  }

  /** Llamada gRPC-Web del guardado + adaptador al tipo de la web. El `upsert` queda en `save()`. */
  protected abstract sendSave(request: TPayload): Promise<TItem>;
}
